export default function Hero() {
  return (
    <section className="relative w-full h-[100vh] min-h-[680px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20stylish%20Japanese%20woman%20in%20her%20early%20thirties%20naturally%20walking%20on%20a%20clean%20urban%20stone%20sidewalk%20wearing%20nude%20beige%20leather%20pumps%2C%20fashion%20magazine%20editorial%20photography%20style%2C%20warm%20golden%20afternoon%20natural%20light%2C%20slim%20fit%20tailored%20beige%20trousers%20and%20silk%20blouse%2C%20graceful%20confident%20posture%2C%20candid%20lifestyle%20shot%2C%20warm%20cream%20and%20neutral%20tones%2C%20professional%20full%20body%20shot%2C%20magazine%20cover%20quality%2C%20no%20product%20shot%2C%20natural%20movement&width=1440&height=900&seq=hero1&orientation=landscape"
          alt="好きな靴を、もっと心地よく履けたら"
          className="w-full h-full object-cover object-center"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/35 to-black/15" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-black/10" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="max-w-xl">
          {/* Tag */}
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 px-4 py-1.5 rounded-full mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4A574]" />
            <span className="text-white/90 text-xs tracking-widest" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              足と靴のフィッティング専門店
            </span>
          </div>

          {/* Main Headline */}
          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.25] mb-6"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            好きな靴を、
            <br />
            もっと心地よく
            <br />
            <span className="text-[#E8C99A]">履けたら。</span>
          </h1>

          {/* Sub copy */}
          <p
            className="text-white/80 text-sm md:text-base leading-loose mb-10 max-w-sm"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            パンプスも、おしゃれも、
            <br />
            <strong className="text-white font-medium">"我慢するもの"ではなく、</strong>
            <br />
            自分の足に合わせて選べるものへ。
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-3">
            <a
              href="#diagnosis"
              className="flex items-center gap-2 bg-white text-[#1C1917] px-6 py-3.5 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-[#F5F0EA] transition-colors cursor-pointer"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              <i className="ri-survey-line" />
              3分で足タイプ診断
              <i className="ri-arrow-right-line text-xs" />
            </a>
            <a
              href="#about"
              className="flex items-center gap-2 border border-white/60 text-white px-6 py-3.5 rounded-full text-sm font-medium whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              初めての方へ
            </a>
          </div>

          {/* Trust indicators */}
          <div className="flex items-center gap-6 mt-10">
            {[
              { icon: "ri-ruler-2-line", label: "足計測無料" },
              { icon: "ri-store-2-line", label: "完全予約制" },
              { icon: "ri-heart-line", label: "細幅・小さいサイズ対応" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-1.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-white/60 text-sm`} />
                </div>
                <span className="text-white/60 text-xs whitespace-nowrap" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60">
        <span className="text-white text-[10px] tracking-widest" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          SCROLL
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-white to-transparent animate-pulse" />
      </div>
    </section>
  );
}